import { ImpactLensType } from '@upright/common/impact-lenses/types';
import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import { PaiBoxes } from '@upright/ui/common/upright/core/impact-lenses/pais/data-area/pai-boxes';
import { PaiLensEmptyState } from '@upright/ui/common/upright/core/impact-lenses/pais/empty-state';
import { PaiInfoBoxes } from '@upright/ui/common/upright/core/impact-lenses/pais/info-boxes';
import { PaiInfoBoxConnector } from '@upright/ui/common/upright/core/impact-lenses/pais/info-boxes/pai-info-box-connector';
import { paiLensSelectionState } from '@upright/ui/common/upright/core/impact-lenses/pais/selection-state/single-impact-selection-state';
import { paiLensTexts } from '@upright/ui/common/upright/core/impact-lenses/pais/texts';
import { PaiLensData, PaiLensOptions } from '@upright/ui/common/upright/core/impact-lenses/pais/types';
import { ImpactLens } from '@upright/ui/common/upright/core/impact-lenses/types';

export const paisLens: ImpactLens<ImpactLensType.EU_PAIS, PaiLensData, PaiLensOptions> = {
  type: ImpactLensType.EU_PAIS,
  ImpactDataComponent: { component: PaiBoxes },
  infoBoxes: {
    DivComponent: PaiInfoBoxes,
    SvgComponent: PaiInfoBoxConnector,
  },
  boxMode: (fullWidth: number) => {
    if (fullWidth < 940) {
      return LensBoxMode.MODAL;
    }
    return LensBoxMode.SIDE;
  },
  boxesAreaWidth: (_fullWidth: number) => {
    return 220;
  },
  aggregateResultAreaHeight: (_fullWidth: number) => {
    return 15;
  },
  EmptyState: PaiLensEmptyState,
  ...paiLensSelectionState,
  ...paiLensTexts,
};
